"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchWrapper = exports.SearchPopover = exports.SearchItemLink = exports.SearchItemEmpty = exports.SearchInput = exports.Panel = exports.Empty = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Panel = _interopRequireDefault(require("../../../../components/Panel"));
var _styles = require("../../../../components/Panel/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SearchWrapper = exports.SearchWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__SearchWrapper",
  componentId: "sc-wyu4ez-0"
})(["display:flex;flex-direction:row;"]);
const SearchInput = exports.SearchInput = _styledComponents.default.input.withConfig({
  displayName: "styles__SearchInput",
  componentId: "sc-wyu4ez-1"
})(["color:", ";height:", ";outline:none;border:0;background:transparent;border-bottom:1px solid ", ";width:", ";transition:width 0.3s ease-in-out;margin-left:", ";"], ({
  theme
}) => theme.colors.appFrame.header.placeholder, ({
  theme
}) => theme.AppFrame.header.searchPanel.inputHeight, ({
  theme
}) => theme.colors.appFrame.header.searchBorder, ({
  expanded
}) => expanded ? '140px' : 0, ({
  theme
}) => theme.AppFrame.header.searchPanel.inputLeftMaring);
const SearchPopover = exports.SearchPopover = _styledComponents.default.div.withConfig({
  displayName: "styles__SearchPopover",
  componentId: "sc-wyu4ez-2"
})(["padding-top:5px;z-index:300;"]);
const Panel = exports.Panel = (0, _styledComponents.default)(_Panel.default).withConfig({
  displayName: "styles__Panel",
  componentId: "sc-wyu4ez-3"
})(["width:280px;padding:8px 0;background:", ";", "{height:40px;}", "{", ";}"], ({
  theme
}) => theme.colors.appFrame.header.searchPanelBg, _styles.SHeader, _styles.SBody, ({
  isPopup,
  theme
}) => isPopup && (0, _styledComponents.css)(["background:", ";box-shadow:none;"], theme.colors.appFrame.bellWidget.contentBg));
const SearchItemLink = exports.SearchItemLink = _styledComponents.default.a.withConfig({
  displayName: "styles__SearchItemLink",
  componentId: "sc-wyu4ez-4"
})(["padding:8px 15px;display:block;background:", ";& span{display:block;color:", ";font-size:14px;font-weight:300;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;& b{font-weight:", ";}& i{font-style:normal;}}&:hover{background:", ";}&:last-child{border:none;}"], ({
  theme
}) => theme.colors.appFrame.header.searchPanelBg, ({
  theme
}) => theme.colors.appFrame.header.searchPanelText, ({
  theme
}) => theme.AppFrame.header.searchPanel.selectedCharFontWeight, ({
  theme
}) => theme.colors.appFrame.header.searchPanelHover);
const SearchItemEmpty = exports.SearchItemEmpty = _styledComponents.default.div.withConfig({
  displayName: "styles__SearchItemEmpty",
  componentId: "sc-wyu4ez-5"
})(["background:", ";display:block;text-align:center;padding:8px 15px;"], ({
  theme
}) => theme.colors.appFrame.header.searchPanelBg);
const Empty = exports.Empty = _styledComponents.default.span.withConfig({
  displayName: "styles__Empty",
  componentId: "sc-wyu4ez-6"
})(["color:", ";font-size:14px;font-weight:300;user-select:none;"], ({
  theme
}) => theme.colors.appFrame.header.searchPanelText);